import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import { useAssetContext } from "../../DataContext/AssetContext";

const DateDisplayWithPicker = () => {
  const {
    selectedDateRange,
    setSelectedDateRange,
    setStartDate,
    setEndDate,
    activeTabLabel,
  } = useAssetContext();

  const isAssetRevenue = activeTabLabel === "Asset Revenue";

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  // useEffect(() => {
  //   if (isAssetRevenue) {
  //     const yesterday = dayjs().subtract(1, "day");
  //     const formatted = yesterday.format("YYYY-MM-DD");

  //     setSelectedDate(yesterday.toDate());
  //     setSelectedDateRange(formatted);
  //     setStartDate(formatted);
  //     setEndDate(formatted);
  //   }
  // }, [isAssetRevenue]);
  useEffect(() => {
  if (
    !isAssetRevenue ||
    selectedDateRange !== "yesterday"
  ) {
    return;
  }

  const yesterdayObj = dayjs().subtract(1, "day");
  const formatted =
    yesterdayObj.format("YYYY-MM-DD");

  setSelectedDate(
    yesterdayObj.toDate()
  );

  setSelectedDateRange(
    formatted
  );

  setStartDate(formatted);
  setEndDate(formatted);
}, [
  isAssetRevenue,
  selectedDateRange,
]);

  useEffect(() => {
    if (!isAssetRevenue || !selectedDateRange || selectedDateRange === "yesterday") {
      return;
    }

    const date = dayjs(selectedDateRange);
    if (date.isValid()) {
      setSelectedDate(date.toDate());
    }
  }, [isAssetRevenue, selectedDateRange]);

  const handleChange = (date: Date | null) => {
    if (!date) return;

    setSelectedDate(date);
  };

  const handleApply = () => {
    if (!selectedDate) return;

    const formatted = dayjs(selectedDate).format("YYYY-MM-DD");

    if (selectedDateRange !== formatted) {
      setSelectedDateRange(formatted);
      setStartDate(formatted);
      setEndDate(formatted);
    }
  };

  const formatDate = () => {
    if (!selectedDateRange) return "";

    return dayjs(selectedDateRange).isValid()
      ? dayjs(selectedDateRange).format("MM-DD-YYYY")
      : "";
  };

  const appliedDate = selectedDateRange === "yesterday"
    ? dayjs().subtract(1, "day")
    : dayjs(selectedDateRange);
  const hasAppliedDate = appliedDate.isValid();
  const formatRange = (start: dayjs.Dayjs) =>
    `${start.format("MM-DD-YYYY")} - ${appliedDate.format("MM-DD-YYYY")}`;

  return (
    <div className="flex flex-col items-start gap-1">

      {isAssetRevenue && (
        <>
          <div className="flex items-center gap-3">
            <DatePicker
              selected={selectedDate}
              onChange={handleChange}
              dateFormat="MM-dd-yyyy"
              maxDate={dayjs().subtract(1, "day").toDate()}
              onKeyDown={(event) => event.preventDefault()}
              onChangeRaw={(event) => event?.preventDefault()}
              className="border border-gray-300 rounded px-2 py-1 text-sm"
            />
            <button
              type="button"
              onClick={handleApply}
              disabled={!selectedDate || dayjs(selectedDateRange).isSame(selectedDate, "day")}
              className="rounded bg-[#6C63FF] px-3 py-1 text-sm font-semibold text-white transition-colors hover:bg-[#584FE0] disabled:cursor-not-allowed disabled:opacity-50"
            >
              Apply
            </button>
          </div>
          {hasAppliedDate && (
            <div className="space-y-1 text-xs leading-4 text-gray-600">
              <div className="flex">
                <span className="w-10 shrink-0 pr-2 text-right">MTD:</span>
                <span className="tabular-nums">{formatRange(appliedDate.startOf("month"))}</span>
              </div>
              <div className="flex">
                <span className="w-10 shrink-0 pr-2 text-right">YTD:</span>
                <span className="tabular-nums">{formatRange(appliedDate.startOf("year"))}</span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DateDisplayWithPicker;